var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDdaClosingReportWithGaps = function SvgDdaClosingReportWithGaps(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FDE7E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6705 15.334C12.6705 15.7022 12.3721 16.0007 12.0039 16.0007C11.6357 16.0007 11.3372 15.7022 11.3372 15.334C11.3372 14.9659 11.6357 14.6674 12.0039 14.6674C12.3721 14.6674 12.6705 14.9659 12.6705 15.334Z",
    fill: "#D80E25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1279 6.48066C10.9485 5.0403 13.0593 5.0403 13.8799 6.48066L18.9946 15.4583C19.8093 16.8882 18.7343 18.6004 17.1186 18.6004H6.88914C5.27348 18.6004 4.19851 16.8882 5.01313 15.4583L10.1279 6.48066ZM12.8372 7.07468C12.4769 6.44229 11.5308 6.44229 11.1705 7.07468L6.05579 16.0523C5.72273 16.637 6.14156 17.4004 6.88914 17.4004H17.1186C17.8662 17.4004 18.285 16.637 17.952 16.0523L12.8372 7.07468ZM12.0038 9.40037C12.3352 9.40037 12.6038 9.669 12.6038 10.0004V13.3337C12.6038 13.6651 12.3352 13.9337 12.0038 13.9337C11.6725 13.9337 11.4038 13.6651 11.4038 13.3337V10.0004C11.4038 9.669 11.6725 9.40037 12.0038 9.40037Z",
    fill: "#D80E25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDdaClosingReportWithGaps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dda-closing-report-with-gaps.0be5cc2d66296fb944638fc86279547f.svg";